import { useTheme } from "react-jss";
import { useTranslation } from "react-i18next";
import { IConfigDockMerchandiseForm } from "../../../../models/config/dockMerchandise";
import { fetchConfigDockMerchandiseListAction } from "../../../../redux/actions/config/dockMerchandise";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { resetConfigDockMerchandiseFilter, updateFilterProperty } from "../../../../redux/reducers/config/dockMerchandise/filter";
import { compileNameOfProperty } from "../../../../utils";
import { FilterHeader } from "../../../common/filterHeader/filterHeader";
import { BooleaMultiSelector } from "../../../common/selectors";
import { CustomDocksSelector } from "../../../request/common/selectors/docks/customDockSelector";
import { CustomMerchandiseOriginSelector } from "../../../request/common/selectors/merchandiseOrigin/customMerchandiseOrigin";
import { CustomMerchandiseTypeSelector } from "../../../request/common/selectors/merchandiseType/customMerchandiseTypeSelector";
import { filterStyle } from "./filterStyle.jss";
import { DefaultValues } from "../../../../common/enum/DefaultValues";

export const ConfigDockMerchandiseFilter = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation("common", { keyPrefix: "CONFIG" });
    const { filter } = useAppSelector((state) => state.configDockMerchandiseFilter);
    const theme = useTheme();
    const style = filterStyle({ theme });
    const updateProperty = (name: string, value: any) => {
        dispatch(updateFilterProperty({ name, value }));
    };
    const onSelectorChange = (name: string, option: any) => {
        updateProperty(name, option.key);
    };
    const onBooleanSelectorChange = (name: string, nullablebooleanValue: any) => {
        updateProperty(name, nullablebooleanValue);
    };

    const contetFilter = (
        <div className={style.filter}>
            <div className={style.section}>
                <CustomDocksSelector
                    title={t("DOCK_MERCHANDISE.DOCK")}
                    onChange={onSelectorChange}
                    selectedKey={filter.dockId !== -1 ? filter.dockId : DefaultValues.DEFAULT_ALL_SELECTOR}
                    name={compileNameOfProperty<IConfigDockMerchandiseForm>("dockId")}
                ></CustomDocksSelector>
                <CustomMerchandiseTypeSelector
                    onChange={onSelectorChange}
                    selectedKey={filter.merchandiseTypeId !== -1 ? filter.merchandiseTypeId : DefaultValues.DEFAULT_ALL_SELECTOR}
                    name={compileNameOfProperty<IConfigDockMerchandiseForm>("merchandiseTypeId")}
                    title={t("MERCHANDISE_TYPE")}
                />
                <CustomMerchandiseOriginSelector
                    title={t("MERCHANDISE_ORIGIN")}
                    onChange={onSelectorChange}
                    selectedKey={filter.merchandiseOriginId !== -1 ? filter.merchandiseOriginId : DefaultValues.DEFAULT_ALL_SELECTOR}
                    name={compileNameOfProperty<IConfigDockMerchandiseForm>("merchandiseOriginId")}
                />
            </div>
            <div className={style.section}>
                <BooleaMultiSelector
                    selectedKey={filter.humanConsumption}
                    propertyName={compileNameOfProperty<IConfigDockMerchandiseForm>("humanConsumption")}
                    title={t("HUMAN_CONSUMPTION")}
                    onChange={onBooleanSelectorChange}
                />
                <BooleaMultiSelector
                    selectedKey={filter.halalCertified}
                    propertyName={compileNameOfProperty<IConfigDockMerchandiseForm>("halalCertified")}
                    title={t("HALAL_CERTIFIED")}
                    onChange={onBooleanSelectorChange}
                />
                <BooleaMultiSelector
                    selectedKey={filter.fumigated}
                    propertyName={compileNameOfProperty<IConfigDockMerchandiseForm>("fumigated")}
                    title={t("FUMIGATED")}
                    onChange={onBooleanSelectorChange}
                />
                <BooleaMultiSelector
                    selectedKey={filter.organicProduct}
                    propertyName={compileNameOfProperty<IConfigDockMerchandiseForm>("organicProduct")}
                    title={t("ORGANIC_PRODUCT")}
                    onChange={onBooleanSelectorChange}
                />
            </div>
        </div>
    );
    const onApplyFilter = () => {
        dispatch(fetchConfigDockMerchandiseListAction());
    };
    const onResetFilter = () => {
        dispatch(resetConfigDockMerchandiseFilter());
        onApplyFilter();
    };

    return (
        <>
            <FilterHeader
                content={contetFilter}
                onApply={onApplyFilter}
                onReset={onResetFilter}
                height={120}
            />
        </>
    );
};
